import { Component, OnInit, ViewChild,  OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IMyDateModel, INgxMyDpOptions } from 'ngx-mydatepicker';
import { AppConstants, SERVER, LOGON_INFO, CODE, CARGO_LIST_TYPE, CARGO_STATUS, IMPORTANCE_TYPE, COMP_TYPE, DATEPICKER, CAR_STATUS } from '../app.constants';
import { CommonService, Code } from '../app.service';
import { MessageService } from '../common/message.service';
import { CargoService } from '../cargo/cargo.service';
import { Case, CaseService } from './case.service';
import { Car, CarService } from '../member-kanri/car.service';
import { Company, CompanyService } from '../member-kanri/company.service';
import { UserService } from '../member-kanri/user.service';
import $ from 'jquery';


export class ScheduleDay {
    dateStr: string;
    dateStrShort: string;
    weekday: string;
    require_car_num: number;
    is_workday: boolean;
    shcedule_flag_list: boolean[]
}

@Component({
    selector: 'case-management',
    templateUrl: 'case-management.component.html',
    providers: [CargoService, CaseService, CompanyService, CarService, UserService]
})
export class CaseManagementComponent implements OnInit, OnDestroy {

    CONST: any = AppConstants;

    CARGO_LIST_TYPE: any = CARGO_LIST_TYPE;
    IMPORTANCE_TYPE: any = IMPORTANCE_TYPE;
    CARGO_STATUS: any = CARGO_STATUS;
    CAR_STATUS: any = CAR_STATUS;

    pageZoom: number = !!localStorage.getItem("case_management_page_zoom") ? +localStorage.getItem("case_management_page_zoom") : 1;

    @ViewChild(NgForm) f: NgForm;

    //ログイン会社情報
    comp_id: string = LOGON_INFO.COMP_ID;
    parent_comp_id: string = LOGON_INFO.PARENT_COMP_ID;

    timeDivideCodeList: Code[];
    loadMethodCodeList: Code[];
    carAbilityCodeList: Code[];
    chargeUnitCodeList: Code[];
    todohukenList: any[];

    carList: Car[];
    selCar: Car;

    branchList: Company[] = [];
    clientList: Company[] = [];
    partnerList: Company[] = [];

    selectCargoTrans: string;

    caseList: Case[] = [];
    caseListAll: Case[];
    currentCase: Case;

    totalCount: number;

    //スケジュール表示切り替え用
    startDate: Date = new Date();

    //地図表示用
    isMapShow: boolean = true;
    origin: any;
    destination: any;

    search_div: string;
    search_keyword: string = "";

    myDatePickerOptions: INgxMyDpOptions = DATEPICKER.myDatePickerOptions;
    myDatePickerOptions_noDisableUntil: INgxMyDpOptions = DATEPICKER.myDatePickerOptions_noDisableUntil;

    transSocket: any;

    search_load_date_start: any;
    search_load_date_end: any;
    search_branch: string = "";
    search_date: any;

    hour_list: string[] = ["00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24"];

    schedule_day_list: ScheduleDay[] = [];
    car_match_info: Object[][] = [[]];
    car_schedule_info: Object[][] = [[]];

    error_msg: string = "";
    car_match_error_msg: string = "";

    carAlertList: any[];


    constructor(
        private commonService: CommonService,
        private caseService: CaseService,
        private msgService: MessageService,
        private companyService: CompanyService,
        private carService: CarService,
        public messageService: MessageService
    ) {  }


    async ngOnInit() {
        this.chargeUnitCodeList = CODE.CHARGE_UNIT;
        this.carAbilityCodeList = CODE.CAR_ABILITY;

        this.clearCurrentCase();
        
        this.getCaseList(CARGO_LIST_TYPE.ORDER, '', null, null);

        this.getBranchList();
        this.getClientList();

        this.getAllCarList();

        this.transSocket = new WebSocket(SERVER.caseSocketURL + '/transport/');
        this.transSocket.addEventListener("message", (event) => {
            var data = JSON.parse(event.data);
            var div: string = data['div'];
            var c: Case = data['case'];
            this.autoRefresh(div, c);
        });

        //車検警告対象の車両を取得
        //this.alertInspectionExpireCarList();
    }


    //ページのズームイン、ズームアウト
    changeZoom(num: number) {
        if ((num > 0 && this.pageZoom >= 1.2) || (num < 0 && this.pageZoom <= 0.6)) {
            return;
        }
        this.pageZoom = this.pageZoom + num;
        localStorage.setItem("case_management_page_zoom", this.pageZoom.toString());
    }


    clearCurrentCase(): void {
        let now = new Date();
        
        //入力formを初期化
        this.currentCase = new Case();
        this.currentCase.trans_comp_id = this.comp_id;
        this.currentCase.day_night = '1';
        this.currentCase.start_date = { jsdate: now, formatted: now.toLocaleDateString() };
        this.currentCase.end_date = { jsdate: now, formatted: now.toLocaleDateString() };
        this.currentCase.start_time = "09";
        this.currentCase.end_time = "18";

        let week = [ "日", "月", "火", "水", "木", "金", "土" ][now.getDay()];
        this.currentCase.require_car_num_viewlist = [{ timestamp: now.getTime(), date_str: (now.getMonth()+1) + "/" + now.getDate() + "(" + week + ")", require_car_num: null,  weekday: week}];
        
        this.f.resetForm(this.currentCase);

        //表示中のマウス右メニューを非表示
        this.hideRightClickMenu();
    }


    //案件リスト取得（直近100件までを取得）
    getCaseList(list_type:string, trans_comp_id, searchStartDate:any, searchEndDate:any) {
        if (!searchStartDate) {
            searchStartDate = this.search_load_date_start;
        }
        if (!searchEndDate) {
            searchEndDate = this.search_load_date_end;
        }

        this.caseService.getCaseList(list_type, 1, trans_comp_id, '', searchStartDate, searchEndDate)
                .take(1).subscribe(
                    data => {
                        this.caseList = [];
                        this.caseListAll = data['results'];
                        this.totalCount = data['count'];

                        for (var i=0; i<this.caseListAll.length; i++) {
                            let c = this.caseListAll[i]
                            let sd = new Date(c.start_date);
                            let ed = new Date(c.end_date);
                            c.start_date = { jsdate: sd, formatted: sd.toLocaleDateString() };
                            c.end_date = { jsdate: ed, formatted: ed.toLocaleDateString() };
                            c.start_time = ("00" + sd.getHours()).slice(-2);
                            c.end_time = ("00" + ed.getHours()).slice(-2);
                            c.tooltip = "請求先： " + c.client_comp_name
                                      + "<br>荷　主： " + c.customer_1 + "　" + c.customer_2 + "　" + c.customer_3
                                      + "<br>場　所： " + c.work_place + " (" + c.distance + "km)"
                                      + "<br>品　名： " + c.cargo_item
                                      + "<br>備　考： " + (!!c.etc ? c.etc : "");

                            this.caseList.push(c);
                        }
                    }
                );
    }


    mouseRightClick(e: any, cs: Case) {
        //表示中のマウス右メニューを非表示
        this.hideRightClickMenu();
        
        //ログイン会社が発注窓口 or 親会社である場合
        if (this.comp_id == cs.trans_comp_id || this.comp_id == this.parent_comp_id) {
            //objectをコピー＆初期化
            this.currentCase = Object.assign({},cs);
        }

        if (cs.status != CARGO_STATUS.NO_ACCEPT && cs.status != CARGO_STATUS.CANCEL && cs.status != CARGO_STATUS.TRANS_END) {
            $("#rightClickMenu").css({
                display: "block",
                left: e.pageX,
                top: e.pageY
            });
        }

        //falseを返して、ブラウザのcontextmenuを非表示にする
        return false;
    }


    caseRegistModalShow(execDiv: string) {
        this.hideRightClickMenu();

        if (execDiv == this.CONST.REGIST) {
            this.clearCurrentCase();
            $('#caseRegistModal .modal-title').text('【 案件登録 】');
        } else {
            let idx = 0;
            this.currentCase.require_car_num_viewlist = [];
            let car_num_list: string[] = this.currentCase.require_car_num.split(',');
            let sd = new Date(this.currentCase.start_date.jsdate.getTime());   sd.setHours(+this.currentCase.start_time, 0, 0);
            let ed = this.currentCase.end_date.jsdate;                         ed.setHours(+this.currentCase.end_time, 0, 0);

            for (let d = sd; d <= ed; d.setDate(d.getDate()+1)) {
                this.currentCase.require_car_num_viewlist.push({ timestamp: d.getTime(), date_str: this.commonService.getDateStrShort(d), require_car_num: +car_num_list[idx], weekday: this.commonService.getDayOfWeek(d)});
                idx++;
            }

            $('#caseRegistModal .modal-title').text('【 案件修正 】');
        }

        $('#caseRegistModal').modal('show');
    }


    //グループ内の全車両を取得
    getAllCarList() {
        this.carList = this.carService.getDispatchTargetCarList();
    }
    

    //配車登録モーダルを開く
    async carSelectModalShow(cs: Case) {
        if (!this.carList || this.carList.length == 0) {
            this.messageService.addError("配車対象の車両リスト取得に失敗しました。");
            return;
        }
        
        //表示中のマウス右メニューを非表示
        this.hideRightClickMenu();

        this.currentCase = Object.assign({},cs);

        this.schedule_day_list = [];
        this.car_match_info = [];
        this.car_schedule_info = [];

        let work_sd: Date = new Date(cs.start_date.jsdate.getFullYear(), cs.start_date.jsdate.getMonth(), cs.start_date.jsdate.getDate(), 0, 0, 0);
        let work_ed: Date = new Date(cs.end_date.jsdate.getFullYear(), cs.end_date.jsdate.getMonth(), cs.end_date.jsdate.getDate(), 0, 0, 0);
        let view_sd = new Date(cs.start_date.jsdate.getFullYear(), cs.start_date.jsdate.getMonth(), cs.start_date.jsdate.getDate(), 0, 0, 0);
        let view_ed = new Date(cs.start_date.jsdate.getFullYear(), cs.start_date.jsdate.getMonth(), cs.start_date.jsdate.getDate(), 0, 0, 0);
        let viewSize = (work_ed.getTime() - work_sd.getTime()) / 86400000 + 5;
        viewSize = viewSize < 10 ? 10 : viewSize;
        view_sd.setDate(view_sd.getDate() - 3);
        view_ed.setDate(view_ed.getDate() - 3 + viewSize);

        //車両の運送スケジュールを取得
        let scheduleList: any[] = [];
        const scheduleListFromBackend = await this.caseService.getCarScheduleList(cs.id, this.commonService.getDateStr(view_sd), this.commonService.getDateStr(view_ed));
        scheduleList = scheduleListFromBackend['results'];

        let require_car_num_list: string[] = this.currentCase.require_car_num.split(',');

        let j=0;
        let dateStrLong = "";   //yyyy-mm-dd
        
        for (let i=1; i<=viewSize; i++) {
            let require_car_num = 0;
            view_sd.setDate(view_sd.getDate()+1);
            dateStrLong = this.commonService.getDateStr(view_sd);
            let shcedule_flag_list: boolean[] = [];

            this.carList.forEach(async car => {
                const is_exist_schedule = await scheduleList.some(obj => obj.case_id != cs.id && obj.work_date == dateStrLong && obj.car_id == car.id);
                shcedule_flag_list.push(is_exist_schedule);
            })

            const is_workday = work_sd.getTime() <= view_sd.getTime() && view_sd.getTime() <= work_ed.getTime();
            
            if (is_workday) {
                require_car_num = +require_car_num_list[j++];
                

                let innerArray: Object[] = [];
                this.carList.forEach(async car => {
                    const is_exist_matched_car = await scheduleList.some(obj => obj.case_id == cs.id && obj.work_date == dateStrLong && obj.car_id == car.id);
                    innerArray.push(is_exist_matched_car);
                })

                this.car_match_info.push(innerArray);
            }
            
            this.schedule_day_list.push({
                dateStr: dateStrLong,
                dateStrShort: this.commonService.getDateStrShort(view_sd),
                weekday: this.commonService.getDayOfWeek(view_sd),
                require_car_num: require_car_num,
                is_workday: is_workday,
                shcedule_flag_list: shcedule_flag_list
            });
        }

        $('#carSelectModal').modal('show');
    }


    autoRefresh(div: string, c: Case) {
        switch (div) {
            //案件新規登録された場合
            case AppConstants.REGIST:
                //全体公開 または 自社へのみ公開の案件の場合
                if (this.caseService.isAccessibleCase(c)) {
                    //リスト先頭に案件追加
                    if (this.commonService.isBetweenDate(c.start_date, this.search_load_date_start, this.search_load_date_end)
                          || this.commonService.isBetweenDate(c.end_date, this.search_load_date_start, this.search_load_date_end)) {
                        if (this.caseService.addCaseToList(this.caseListAll, c)) {
                            this.msgService.addInfo(c.trans_comp_name+"から案件新規登録されました。");
                        }
                    }
                }
                break;
            //案件情報更新(取消含む)された場合
            case AppConstants.UPDATE:
                //表示中であれば入れ替え
                if (!this.caseService.replaceCaseFromList(this.caseListAll, c)) {
                    this.caseService.replaceCaseFromList(this.caseListAll, c);
                }
                if (!this.caseService.replaceCaseFromList(this.caseList, c)) {
                    this.caseService.replaceCaseFromList(this.caseList, c);
                }
                break;
        }
    }


    //支店リストを取得
    getBranchList() {
        if (LOGON_INFO.COMP_TYPE == COMP_TYPE.HEAD || LOGON_INFO.COMP_TYPE == COMP_TYPE.BRANCH) {
            // this.companyService.getCompanyList(1, false, true)
            // .take(1).subscribe(
            //     data => {
            //         this.branchList = data['results'];
            //         //this.branchList.splice(this.branchList.findIndex(({comp_id}) => comp_id === this.comp_id), 1);
            //         this.branchList.splice(this.branchList.findIndex(({comp_type}) => comp_type === COMP_TYPE.HEAD), 1);
            //     }
            // );

            this.branchList = this.companyService.getCompanyListForCombo();
        }
    }


    //顧客リストを取得
    getClientList() {
        this.companyService.getClientList(1, false)
            .take(1).subscribe(
                data => {
                    this.clientList = data['results'];
                }
            );
    }


    //画面リフレッシュ
    refreshPage(div: string, case_id: number): void {
        this.search_branch = "";
        this.search_date = "";

        if (!!case_id) {
            //send websocket  
            this.transSocket.send(JSON.stringify({
                'div': div,
                'case_id': case_id
            }));
        }
        this.clearCurrentCase();
        $('#caseRegistModal').modal('hide');
        $('#carSelectModal').modal('hide');
        this.getCaseList(CARGO_LIST_TYPE.ORDER, '', null, null);
    }


    searchCaseList(event: IMyDateModel) {
        console.log("searchCaseList!  " + this.search_branch)
        if (event) {
            this.search_date = event
        }
        this.getCaseList(CARGO_LIST_TYPE.ORDER, this.search_branch, this.search_date, null);
    }


    updateStatus(status: string) {
        this.caseService.updateCaseStatus(this.currentCase.id, status)
        .take(1).subscribe(
            data => {
                this.currentCase.status = status;
                this.caseList.splice(this.caseList.findIndex(({id}) => id === this.currentCase.id), 1, this.currentCase);
                this.clearCurrentCase();
            }
        );
    }


    changeImportance(importance: string) {
        this.caseService.updateCaseImportance(this.currentCase.id, importance)
        .take(1).subscribe(
            data => {
                this.currentCase.importance = importance;
                this.caseList.splice(this.caseList.findIndex(({id}) => id === this.currentCase.id), 1, this.currentCase);
                this.clearCurrentCase();
            }
        );
    }


    exec() {
        switch ($('#confirmModal_btn').text()) {
            case "登録":
                this.registCase(CARGO_STATUS.REGIST);
                break;
            case "修正":
                this.updateCase();
                break;
            case "取消":
                this.updateStatus(CARGO_STATUS.CANCEL);
                break;
            case "配車登録":
                // if (this.currentCase.id) {
                //     this.matchCar();
                // } else {
                //     this.registCase(CARGO_STATUS.MATCH_CAR);
                // }
                break;
        }
    }


    //案件登録
    async registCase(status: string) {
        this.currentCase.status = status;
     
        if(this.commonService.checkStartEndDate(this.currentCase.start_date, this.currentCase.start_time, this.currentCase.end_date, this.currentCase.end_time, false, false, false)) {
            this.currentCase.require_car_num = this.currentCase.require_car_num_viewlist.map(obj => obj.require_car_num).join();
            await this.caseService.registCase(this.currentCase)
                .take(1).subscribe(
                    data => {
                        this.refreshPage(AppConstants.REGIST, data.id);
                    }
                );
        }
    }


    //案件更新
    async updateCase() {
        if(this.commonService.checkStartEndDate(this.currentCase.start_date, this.currentCase.start_time, this.currentCase.end_date, this.currentCase.end_time, false, false, false)) {
            this.currentCase.require_car_num = this.currentCase.require_car_num_viewlist.map(obj => obj.require_car_num).join();
            await this.caseService.updateCase(this.currentCase)
                .take(1).subscribe(
                    data => {
                        this.refreshPage(AppConstants.REGIST, data.id);
                    }
                );
        }
    }


    hideRightClickMenu() {
        $("#rightClickMenu").hide();
    }


    async changeStartEndDate(type: string, event: IMyDateModel) {
        if (event) {
            if (type == "start") {
                let old_sd = new Date(this.currentCase.start_date.jsdate.getTime());   old_sd.setHours(0, 0, 0);
                if (old_sd.getTime() == event.jsdate.getTime())  return;
                this.currentCase.start_date = event;
            } else {
                let old_ed = new Date(this.currentCase.end_date.jsdate.getTime());    old_ed.setHours(0, 0, 0);
                if (old_ed.getTime() == event.jsdate.getTime())  return;
                this.currentCase.end_date = event;
            }
        }

        let sd = new Date(this.currentCase.start_date.jsdate.getTime());   sd.setHours(+this.currentCase.start_time, 0, 0);
        let ed = this.currentCase.end_date.jsdate;                         ed.setHours(+this.currentCase.end_time, 0, 0);

        if (sd.getTime() >= ed.getTime()) {
            this.error_msg = "開始日には終了日より前の日時を入力してください。";
        } else {
            this.error_msg = "";

            if (event) {
                let sd2 = new Date(this.currentCase.start_date.jsdate.getTime());   sd2.setHours(0, 0, 0);
                let ed2 = new Date(this.currentCase.end_date.jsdate.getTime());     ed2.setHours(23, 59, 59);

                let tempList = await this.currentCase.require_car_num_viewlist.filter(obj => sd2.getTime() <= obj.timestamp && obj.timestamp <= ed2.getTime());

                for (let d = sd; d <= ed; d.setDate(d.getDate()+1)) {
                    let dateStr = this.commonService.getDateStr(d);
                    if (tempList.findIndex(obj => obj.date_str == dateStr) == -1) {
                        await tempList.push({ timestamp: d.getTime(), date_str: dateStr, require_car_num: null, weekday: this.commonService.getDayOfWeek(d)});
                    }
                }

                await tempList.sort((a, b) => {
                    if (a.timestamp < b.timestamp) {
                        return -1;
                    } else if (a.timestamp > b.timestamp) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                this.currentCase.require_car_num_viewlist = tempList;
            }
        }
    }


    async registCarMatch() {
        let match_car_list: Object[] = [];
        let day_list: ScheduleDay[] = await this.schedule_day_list.filter((obj) => obj.is_workday == true);
        let require_car_num_list: string[] = this.currentCase.require_car_num.split(',');
        let require_car_num: number = 0;

        for (var i=0; i<this.car_match_info.length; i++) {
            for (var j=0; j<this.car_match_info[i].length; j++) {
                if (this.car_match_info[i][j]) {
                    await match_car_list.push({
                        work_date: day_list[i].dateStr,
                        comp_id: this.carList[j].comp_id,
                        car_id: this.carList[j].id,
                        car_no: this.carList[j].car_no
                    })
                }
            }
        }

        require_car_num_list.forEach(num => {
            require_car_num = require_car_num + +(num);
        })

        if (match_car_list.length > 0) {
            await this.caseService.registMatchCar(this.currentCase.id, match_car_list, require_car_num)
                .subscribe(
                    res => {
                        this.refreshPage(AppConstants.REGIST, this.currentCase.id);
                        this.msgService.addInfo(res['detail']);
                    }
                );
        }

        $('#carSelectModal').modal('hide');
    }


    changeCarMatch(workday_idx: number, require_car_num: number, dateStr: string) {
        if (this.car_match_info[workday_idx].filter((obj) => obj).length > require_car_num) {
            this.car_match_error_msg = dateStr + "の配車台数が必要台数を超過しています！！";
        } else {
            this.car_match_error_msg = "";
        }
    }


    /**
     * 車検満了通知Modalを表示する
     */
    alertInspectionExpireCarList() {
        //ログイン後に既に表示済みの場合は再度表示しない
        if (sessionStorage.getItem("is_alredy_car_alert") != "1") {
            const today = new Date();
            this.carAlertList = this.carService.getAllCarList().filter((e: any) => 
                                    e.inspection_expire_date &&
                                    this.commonService.getDayCnt(today, new Date(e.inspection_expire_date)) < 30
                                );

            if (this.carAlertList.length > 0) {
                //車検満了日の昇順にソートする
                this.carAlertList.sort((a,b) => {
                    return +(a.inspection_expire_date.replaceAll('-','')) > +(b.inspection_expire_date.replaceAll('-','')) ? 1 : -1;
                });

                this.carAlertList.forEach(c => {
                    c.inspection_expire_date = this.commonService.convertDate(c.inspection_expire_date, 'yyyy-MM-dd', true)
                });

                $('#carAlertModal').modal('show');
            }

            sessionStorage.setItem("is_alredy_car_alert", "1");
        }
    }


    ngOnDestroy() {
        this.transSocket.close();

        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }

}


// WEBPACK FOOTER //
// ./src/app/case/case-management.component.ts